import {CommissionItemList, tabs} from "./CommissionCalculationListing.json";
import AppContext, { AppContextProps } from 'containers/context/Context';
import { IconButton, TextField, Typography, Box } from '@mui/material';
import { MobileDatePicker } from '@mui/x-date-pickers';
import  { 
    treeItemClasses,
    TreeItem, 
    TreeView,  
    } from '@mui/lab/';
import { v4 as uuidv4 } from 'uuid';
import {
    CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankIcon,
    IndeterminateCheckBox as IndeterminateCheckBoxIcon,
    ExpandMore as ExpandMoreIcon,
    ExpandLess as ExpandLessIcon,
    CheckBox as CheckBoxIcon,
    House as HomeIcon,
  } from '@mui/icons-material';
import {
    InputAdornment,
} from '@mui/material';
import CalendarIcon from '@mui/icons-material/Event';
import { useLocation, useParams } from "react-router";
import {
    useGetCommissionCalculationListingDataLazyQuery,
    useCreateProjectCommissionCalculationMutation,
    useGetCommissionCalculationListingLazyQuery,
    useCreateCompanyRewardCalculationMutation,
    useGetCompanyRewardDataLazyQuery,
} from 'generated/graphql'
import { useState, useEffect, useContext, useCallback } from "react";
import { SystemMsgs } from 'helpers/Messages/SystemMsg';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import useNav from 'components/RouteService/useNav';
import { 
    FooterButtonContainer, 
    FooterFixedRoot 
} from '@ifca-ui/core/src/components/Footer/Footer';
import { CommonYupValidation } from 'helpers/yup';
import * as yup from 'yup';
import { 
    SubContainerX, 
    useMenuOption, 
    ListItemText, 
    FooterButton, 
    FloatButton, 
    Container, 
    ListItem, 
    MenuItem,
    Card, 
    Tabs,
    Tab
} from "@ifca-ui/core";
import moment  from 'moment';

interface CreateCommissionProps {
    selectDate: string;
    id: number;
    netSales: number;
    commissionAmount: number;
}

export interface CommissionCalculationProps {
    position: string;
    employeeName?: string;
    employeeId?: string;
    unitNo: string;
    salesConvertedStatus: string;
    description: string;
    principal: string;
    effectiveDate: Date;
    paidToDate?: number;
    // release: number; 
    propertyType: string;
    commissionType: string;
    minimumTarget: number;
    salesRegistrationDate?: Date;
    projectCommissionPackageId?: string;
    // commissionPackageTargetId: string;
    companyId: string;
    parentId?: string;
    salesRegistrationNo?: string;
    dealClosure: number;
    overRiding: number;
    unitsSold: number;
    saleId: string;
    unitSum?: number;
    finalContractPrice?: number;
    finalCommission?: number;
    totalFinalContractPrice?: number;
    totalFinalCommission?: number;
    employeeTotalCommission?: number;
    employeeTotalSale?: number;
    companyCommissionTeamId?: string;
    jobPositionId?: string;
    level?: number;
    checked?: boolean;
}

export const CommissionCalculationCreate = () => {
    const { rootState, rootDispatch } = useContext<AppContextProps>(AppContext);
    const teamAssignmentSchema = yup.object().shape({
        selectDate: CommonYupValidation.requireField(SystemMsgs.date()),
    });
    const { projectID }: any = useParams();
    const [generated, setGenerated] = useState(false);
    const location = useLocation()
    const { tabIndexData } = location?.state?.state||{};
    const [tabIndex, setTabIndex] = useState(tabIndexData??0);
    const [CommissionItemListData, setCommissionItemList] = useState([]);
    const [CommmissionCalculationList, setCommissionCalculationList]   = useState<CommissionCalculationProps[]>([]); 
    const { navTo } = useNav()
    const today  = new Date();
    const {
        handleSubmit,
        register,
        control,
        setValue,
        getValues,
        watch,
        reset,
        clearErrors,
        formState: { errors, isSubmitted },
      } = useForm<CreateCommissionProps>({
        defaultValues: {
          id: null,
          selectDate: `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1).toString().padStart(2, '0')}/${today.getFullYear()}`,
          netSales: 0,
          commissionAmount: 0,
        },
        mode: 'onSubmit',
        resolver: yupResolver(teamAssignmentSchema),
      })
    const selectedDate = watch("selectDate");
    const [getCommission, {loading}] = useGetCommissionCalculationListingLazyQuery({
        variables: {
            projectId: projectID,
            inputDate: selectedDate ? moment(selectedDate,  ['DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY'], true).format('YYYY-MM-DD') : null
        },
        onCompleted: (data) => {
            // setCommissionCalculationList([]);
            // setCommissionCalculationList(data.getCommissionCalculationListing);
        }
    });
    const [createProjectCommissionCalculation, {loading: createLoading}] = useCreateProjectCommissionCalculationMutation(
        {
            onError: (error) => {
                throw(error)
            },
            onCompleted: (data) => {
                navTo(`/sales-commission/${projectID}/commission-calculation`,{
                    state:{projectID, tabIndexData: tabIndex}
                });
            },
            
        }
    );
    const [createCompanyRewardCalculation ] = useCreateCompanyRewardCalculationMutation(
        {
            onError(error, clientOptions) {
                throw(error);
            },
            onCompleted(data, clientOptions) {
                navTo(`/sales-commission/${projectID}/commission-calculation`,{
                    state:{projectID, tabIndexData: tabIndex}
                });
            },
        }
    );
    const [checkedData, setCheckedData] =useState([]);
    const [checkedDetailData, setCheckedDetailData] = useState([]);
    const [submittedDateInput, setSubmittedDateInput] = useState<unknown>(today);
    const [CompanyCommissionOptions, setCompanyCommissionOptions] = useState([]);
    const [CompanyCommissionReward, setCompanyCommissionReward] = useState([]);
    const hasSelectedDate = submittedDateInput instanceof Date && !isNaN(submittedDateInput.getTime());
    const [getCompanyRewardListing] = useGetCompanyRewardDataLazyQuery({
        variables:{
            projectId: projectID,
            inputDate: selectedDate ? moment(selectedDate,  ['DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY'], true).format('YYYY-MM-DD') : null
        },
        onCompleted(data) {
        if(!data.getCompanyRewardData) return;
        var newdata = [...data.getCompanyRewardData];
        setCompanyCommissionReward([]);
        setCompanyCommissionReward(newdata);
        }
    });
    const [getData] = useGetCommissionCalculationListingDataLazyQuery({
        variables:{
            projectId: projectID,
            inputDate: selectedDate ? moment(selectedDate,  ['DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY'], true).format('YYYY-MM-DD') : null
        },
        onCompleted(data){
            setCommissionCalculationList([]);
            setCommissionCalculationList(data.getCommissionCalculationListingData);
        }
    })
    const handleGenerate = ()=>{
        setGenerated(!generated);
        if (!generated){
            tabIndex === 0 ?
            getData()
            :
            getCompanyRewardListing();
        }
    }
    const handleCreate = async ()=>{
        if (tabIndex === 0){
            await createProjectCommissionCalculation({
                variables: {
                    input: checkedData,
                    inputDetail: checkedDetailData,
                }
            })
        } else {
            await createCompanyRewardCalculation({
                variables:{
                    input: checkedData,
                    inputDetail: checkedDetailData,
                }
            })
        }
    }
    useEffect(()=>{
        rootDispatch({
            type: 'headerComponent',
            payload: {
                ...rootState.headerComponent,
                leftIcon: {
                    icon: 'close',
                    props: {
                        onClick: () => {
                            navTo(`/sales-commission/${projectID}/commission-calculation`,{
                                state:{projectID, tabIndexData: tabIndex}
                            });
                        },
                    },
                },
                bottomSection: {
                    breadcrumbs: {
                        current: `Commission Calculation`,
                        maxItems: 1,
                    },
                },
                rightIcon: {}
            }
        })
    },[])
    useEffect(() => {
        if (CommmissionCalculationList||CommmissionCalculationList.length==0){
            setCommissionItemList([]);
            const newNode = new Map<string, any>();
            let tempFinal=0;
            CommmissionCalculationList?.forEach((item: CommissionCalculationProps, index, array) => {
                const back = index > 0 ? CommmissionCalculationList[index-1] : null;
                const key = `${item.employeeName}|${item.principal}`;
                const exists = CommissionItemListData.some(existingItem =>
                existingItem.employeeName === item.employeeName &&
                existingItem.name === item.principal &&
                existingItem.commissionType === item.commissionType
                );
                tempFinal += item.totalFinalCommission || 0;
                if (!newNode.has(key)&& !exists) {
                    newNode.set(key, {
                        id: `${uuidv4()}`,
                        label: `${item.unitNo}`,
                        name: item.principal,
                        description: item.description,
                        netSelling: item.employeeTotalSale,
                        employeeName: item.employeeName, 
                        parentItem: true, 
                        salesCommission: item.employeeTotalCommission,
                        employeeId: item.employeeId,
                        salesRegistrationNo: item.salesRegistrationNo,
                        ...item, 
                        saleId: item.saleId,
                        children:[]
                    })
                }
                const header = newNode.get(key);
                let display  = header?.children?.find((detail)=>detail.unitNo===item.unitNo);
                if (!display){
                    display = {
                        id: `${uuidv4()}`,
                        unitNo: item.unitNo,
                        effectiveDate: item.effectiveDate?moment(item.effectiveDate).format('DD/MM/YYYY'):null,
                        dealClosure: item.dealClosure.toString(),
                        overRiding: item.overRiding.toString(),
                        netSelling: item.finalContractPrice,
                        salesCommissionData: item.totalFinalCommission,
                        childItem: true,
                        children: [
                            ...([]),
                        ],
                        ...item,
                        description: item.salesRegistrationNo,
                    }
                    header?.children?.push(display);
                }
                if (item) {
                    display.children.push(
                        {
                            id: `${uuidv4()}`, 
                            hasBulletList: true,
                            parentOverRiding: item.overRiding.toString(), 
                            currentDealClosure: item.dealClosure.toString(),
                            netSelling: item.finalContractPrice,
                            description: item.salesRegistrationNo,
                            projectCommissionPackageId: item.projectCommissionPackageId,
                            finalCommission: item.finalCommission,
                            effectiveDate: item.effectiveDate ? moment(item.effectiveDate).format('DD/MM/YYYY'):null,
                            ...item,
                            saleId: item.saleId,
                        },
                    )
                }
            });
            const result = Array.from(newNode.values());
            // function updateValues(node) {
            // let totalOverRiding = node.overRiding || 0;
            // let totalSalesCommission = node.dealClosure || 0;

            // if (node.children && node.children.length > 0) {
            //     totalOverRiding = 0;
            //     totalSalesCommission = 0;

            //     node.children.forEach(child => {
            //     const childTotals = updateValues(child);
            //     totalOverRiding += childTotals.overRiding;
            //     totalSalesCommission += childTotals.dealClosure;
            //     });

            //     // update current parent node with totals
            //     node.overRiding = totalOverRiding;
            //     // node.salesCommission = totalSalesCommission;
            // }

            // return {
            //     overRiding: node.overRiding || 0,
            //     salesCommission: node.salesCommission || 0,
            //     dealClosure: node.dealClosure || 0,
            // };
            // }
            setCommissionItemList((prevList) => {
                const updatedList = [...prevList, ...result];
            //     updatedList.forEach((item) => {
            //         updateValues(item);
            //     })
                return updatedList;
            });
        }
    },[CommmissionCalculationList])
    useEffect(()=>{
        if (CompanyCommissionReward||CompanyCommissionReward.length==0){
            const newNode = new Map<string, any>();
            setCompanyCommissionOptions([]);
            CompanyCommissionReward?.map((item: any,index, array) => {
                const back = index > 0 ? CommmissionCalculationList[index-1] : null;
                const key = `${item.employeeName}|${item.principal}`;
                const exists = CommissionItemListData.some(existingItem =>
                    existingItem.employeeName === item.employeeName &&
                    existingItem.name === item.principal &&
                    existingItem.commissionType === item.commissionType
                );
                let tempFinal= 0;
                if (!newNode.has(key)&& !exists) {
                    newNode.set(key, {
                        id: `${item.id}`,
                        label: `${item.unitNo}`,
                        name: item.principal,
                        description: item.description,
                        position: item.jobPosition,
                        netSelling: item.employeeTotalSale,
                        companyId: item.companyId,
                        employeeName: item.employeeName, 
                        parentItem: true, 
                        salesCommission: item.employeeTotalCommission, 
                        principal: item.principal,
                        employeeId: item.employeeId,
                        salesRegistrationNo: item.salesRegistrationNo,
                        totalFinalCommission: item.totalFinalCommission,
                        children:[]
                    })
                }
                const header = newNode.get(key);
                let display = header?.children?.find((detail)=>detail.unitNo===item.unitNo);
                if (!display){
                    display = {
                        id: `${uuidv4()}`,
                        unitNo: item.unitNo,
                        effectiveDate: item.effectiveDate ? moment(item.effectiveDate).format('DD/MM/YYYY'):null,
                        dealClosure: item.dealClosure?item.dealClosure.toString():0,
                        totalFinalCommission: item.totalFinalCommission,
                        overRiding: item.overRiding?.toString()??0,
                        netSelling: item.finalContractPrice??0,
                        salesCommissionData: item.totalFinalCommission??0,
                        childItem: true,
                        children: [
                            ...([]),
                        ],
                        description: item.salesRegistrationNo,
                    }  
                    header?.children?.push(display);
                }
                if (item) {
                    display.children.push({
                        id: `${uuidv4()}`, 
                            hasBulletList: true,
                            dealClosure: item.dealClosure,
                            companyId: item.companyId,
                            companyCommissionPackageId: item.companyCommissionPackageId,
                            saleId: item.saleId, 
                            docDate: item.effectiveDate,
                            docNo: item.unitNo,
                            employeeId: item.employeeId,
                            netSelling: item.finalContractPrice,
                            description: item.commissionType,
                            salesRegistrationDate: item.salesRegistrationDate,
                            effectiveDate: item.effectiveDate,
                            finalCommission: item.finalCommission,
                            totalFinalCommission: item.totalFinalCommission,
                            principal: item.principal,
                            currentDealClosure: item.dealClosure,
                            commissionType: item.commissionType,
                            commissionDate: item.salesRegistrationDate,
                            commissionAmt: item.finalCommission
                    });
                }
            });
            const result = Array.from(newNode.values());
            setCompanyCommissionOptions((prevList) => {
            const updatedList = [...prevList, ...result];
            return updatedList;
            });
        }
    },[CompanyCommissionReward])
    const [expanded, setExpanded] = useState<string[]>([]);
    const handleToggle = (event: React.SyntheticEvent, nodeIds: string[]) => {
        setExpanded(nodeIds);
    };

    const handleExpandClick = (event: React.MouseEvent, nodeId: string) => {
        event.stopPropagation();
        setExpanded((prevExpanded) =>
            prevExpanded.includes(nodeId)
            ? prevExpanded.filter((id) => id !== nodeId)
            : [...prevExpanded, nodeId] 
        );
    };

    const [checkedItems, setCheckedItems] = useState<string[]>([]);
    const updateParentCommission = (nodeId: string, updatedCheckedItems: string[]) => {
        const updateNodeCommission = (node: any): number => {
            if (!node.children || node.children.length === 0) {
                if (updatedCheckedItems.includes(node.id)) {
                    const sc = parseFloat(node.salesCommission?.replace(/,/g, '') || '0');
                    const amount = parseFloat(String(node.dealClosure)?.replace(/,/g, '') || '0');
                    return sc + amount;
                }
                return 0;
            }

            const updateSalesCommission = (node: any): number => {
                if (node.children || node?.children?.length !== 0) {
                    if (updatedCheckedItems.includes(node.id)) {
                        const sales = parseFloat(String(node.overRiding??0)?.replace(/,/g, ''));
                        const amount = parseFloat(String(node.dealClosure)?.replace(/,/g, '') || '0');
                        return sales;
                    }
                    return 0;
                }
                return 0;
            }
    
            let total = 0;
            let totalSell = 0;
            node.children.forEach((child: any) => {
                total += updateNodeCommission(child);
                if (!child.hasBulletList) 
                totalSell += updateSalesCommission(child);
            });
            if (node.parentItem){
                // node.overRiding = totalSell.toString();
            }
            // node.salesCommission = total.toString(); 
            return total;
        };

        const node = findNodeById(nodeId)
        if (!node) return;
        updateNodeCommission(node); 
        
        const findParent = (id: string, nodes: any[], parent: any = null): any => {
            for (const node of nodes) {
                if (node.id === id) return parent;
                if (tabIndex === 0 && node.children) {
                    const result = findParent(id, node.children, node);
                    if (result) return result;
                }
                if (tabIndex!==0 && node.children) {
                    const result = findParent(id, node.children, node);
                    if (result) return result;
                    // for (const payment of node.commissionPayments){
                    //     if (payment.id === id) return node;
                    //     if (payment.children) {
                    //         for (const sub of payment.children) {
                    //             if (sub.id === id) return payment;
                    //         }
                    //     }
                    // }
                }
            }
            return null;
        };
    
        let currentId = nodeId;
        while (true) {
            const parent = tabIndex===0?findParent(currentId, CommissionItemListData):
            findParent(currentId, CompanyCommissionOptions);
            if (!parent || !parent.children) break;
    
            let newSalesCommission = 0;
            parent.children.forEach((child: any) => {
                if (updatedCheckedItems.includes(child.id)) {
                    const sc = parseFloat(String(child.salesCommission??0)?.replace(/,/g, ''));
                    const amount = parseFloat(String(child.dealClosure??0)?.replace(/,/g, ''));
                    newSalesCommission += sc + amount;
                }
            });
            
            // parent.salesCommission = newSalesCommission.toString(); 
            currentId = parent.id;
        }
    };
    function findParentNode(tree, childId) {
    for (const node of tree) {
        if (node.children?.some(child => child.id === childId)) {
            return node; 
        }

        if (node.children?.length) {
            const found = findParentNode(node.children, childId);
            if (found) return found;
        }
    }
        return null;  
    }
    const toggleCheck = (nodeId: string) => {
        const node = findNodeById(nodeId);
        if (!node) return;

        const nodeCheckState = getNodeCheckState(nodeId); 
        const isCurrentlyChecked = nodeCheckState === 'checked'|| nodeCheckState === 'indeterminate'; 

        let updatedCheckedItems = [...checkedItems];
        let updatedToggledItems = [...checkedItems];
        CommissionItemListData.forEach((entity)=>{
            const itemTrack = (node:any)=>{
                const current = getNodeCheckState(node.id);
                if(current==="checked"||current==="indeterminate"){
                    if (!updatedToggledItems.includes(node.id)){
                        updatedToggledItems.push(node.id);
                    }
                }
                if (node.children){
                    node.children.forEach((item:any)=>itemTrack(item))
                }
            }
            itemTrack(entity);
        })
        CompanyCommissionOptions.forEach((entity)=>{
            const itemTrack = (node:any)=>{
                const current = getNodeCheckState(node.id);
                if(current==="checked"||current==="indeterminate"){
                    if (!updatedToggledItems.includes(node.id)){
                        updatedToggledItems.push(node.id);
                    }
                }
                if (node.children){
                    node.children.forEach((item:any)=>itemTrack(item))
                }
            }
            itemTrack(entity);
        })
        const allNodeIds = collectAllNodeIdsIncludingSelf(node);
        let totalNetSales = getValues('netSales') || 0;
        let totalCommission = getValues('commissionAmount') || 0;
        if (tabIndex===0) {
            allNodeIds.forEach(id => {
                const childNode = findNodeById(id);
                const subChildNode = collectAllDescendantIds(childNode);
                if (!childNode) return;
        
                const netSelling = parseFloat(String(node.netSelling??0)?.replace(/,/g, ''));
                const currentOverRiding = parseFloat(String(childNode.parentOverRiding??0).replace(/,/g, ''));
                const salesCommission = parseFloat(String(node.currentDealClosure??0).replace(/,/g, ''));
                const overRiding = parseFloat(String(childNode.overRiding??0).replace(/,/g, ''));
                const dealClosure = parseFloat(String(childNode.totalFinalCommission??0).replace(/,/g, ''));
                const isChecked = updatedCheckedItems.includes(id);
                if (isCurrentlyChecked) {
                    if (isChecked){
                        updatedCheckedItems = updatedCheckedItems.filter(item => item !== id);
                        updatedToggledItems = updatedToggledItems.filter(item => item !== id);
                        if (childNode.hasBulletList){
                            totalCommission = Math.max(0, totalCommission - salesCommission);
                            // totalNetSales = Math.max(0, totalNetSales - netSelling - currentOverRiding);
                        } else if (!childNode.parentItem){
                            node.checked = false;
                            childNode.checked = false;
                            // totalNetSales = Math.max(0, totalNetSales- netSelling - currentOverRiding);
                            totalCommission = Math.max(0, totalCommission - dealClosure);
                        }
                    }
                } else {
                    if (!isChecked) {
                        updatedCheckedItems.push(id);
                        updatedToggledItems.push(id);
                        if (childNode.hasBulletList){
                            // const exists = CommissionItemListData.find(item=>item.children.some(child=>child.id?.toLowerCase()===id?.toLowerCase()))
                            if (findParentNode(CompanyCommissionOptions, id)?.children?.length > 0){
                                //findParentNode(CommissionItemListData, id),
                            }
                            totalCommission += salesCommission;
                            // totalNetSales += netSelling ;
                        }else if (!childNode.parentItem){
                            node.checked = true;
                            childNode.checked = true;
                            // totalNetSales += netSelling + overRiding ;
                            totalCommission += dealClosure;
                        } 
                    }
                }
            });
    
            updatedCheckedItems = syncParentCheckStates(nodeId, updatedCheckedItems);
            updatedToggledItems = syncParentCheckStates(nodeId, updatedToggledItems)
            updateParentCommission(nodeId, updatedCheckedItems);
            
            let currentId = nodeId;
            while (true) {
                const parent = findParent(currentId, CommissionItemListData);
                if (!parent || !parent.children) break;
    
                const allChildrenChecked = parent.children.every((c: any) =>
                    updatedCheckedItems.includes(c.id)
                );
                const someChildrenChecked = parent.children.some((c:any) =>
                    updatedToggledItems.includes(c.id)
                );
                
                const parentIsChecked = updatedCheckedItems.includes(parent.id);
                const parentIsChecked2 = updatedToggledItems.includes(parent.id);
                const parentNetSelling = parseFloat(String(parent.netSelling??0)?.replace(/,/g, ''));
                if (allChildrenChecked && !parentIsChecked) {
                    updatedCheckedItems.push(parent.id);
                    updatedToggledItems.push(parent.id);
                    totalNetSales += parentNetSelling;
                } else if (!allChildrenChecked && parentIsChecked) {
                    updatedCheckedItems = updatedCheckedItems.filter(id => id !== parent.id);
                    totalNetSales = Math.max(0, totalNetSales - parentNetSelling);
                }
                if (someChildrenChecked&& !parentIsChecked2){
                    updatedToggledItems.push(findParent(parent.id, CommissionItemListData)?.id);
                    totalNetSales += parentNetSelling;
                } 
                currentId = parent.id;
            }
            function trackAllItems(node: any, dataList: any[], dataListDetail: any[]){
                const checkState = getNodeCheckState(node.id)
                const itemSelected = updatedToggledItems.includes(node.id)
                if (itemSelected){
                    if(node.parentItem){
                        dataList.push({
                            projectId: projectID,
                            generateDate: submittedDateInput,
                            principal: node.principal,
                            employeeId: node.employeeId,
                            employeeName: node.employeeName,
                            totalSelling: node.finalContractPrice,
                            totalCommission: node.totalFinalCommission
                        });
                    }
                    if (node.hasBulletList){
                        dataListDetail.push({
                            projectId: projectID,
                            saleId: node.saleId,
                            docDate: node.effectiveDate,
                            docNo: node.salesRegistrationNo,
                            employeeId: node.employeeId,
                            principal: node.principal,
                            netSelling: node.netSelling,
                            commissionType: `${node.commissionType}`,//+${node.unitNo}
                            commissionDate: node.salesRegistrationDate,
                            commissionAmt: node.finalCommission,
                            projectCommissionPackageId: node.projectCommissionPackageId,
                        });
                    }
                    
                } 
                if (node.children&&Array.isArray(node.children)){
                for (const child of node.children){
                trackAllItems(child, dataList, dataListDetail)
                }
                }
            }
            const result = [];
            const resultDetail = [];
            totalNetSales = 0;
            updatedToggledItems.forEach((itemData)=>{
                const existItem = findNodeById(itemData)
                if (existItem?.parentItem){
                    totalNetSales += existItem.netSelling + existItem.overRiding;
                }
            })
            for (const checkedItem of CommissionItemListData){
                trackAllItems(checkedItem, result, resultDetail);
            }
            for (const item of result){
                const {employeeId, principal } = item;
                const parentDetail = resultDetail.filter(
                    entity=>entity.employeeId === employeeId && entity.principal===principal
                );
                const sumCommission = parentDetail.reduce((prev, next)=>(prev+(next.commissionAmt||0)),0)
                item.totalCommission = sumCommission;
                
            }
            setCheckedDetailData(resultDetail);
            setCheckedData(result);
        } else {
            allNodeIds.forEach(id => {
                const childNode = findNodeById(id);
                const subChildNode = collectAllDescendantIds(childNode);
                if (!childNode) return;
        
                const netSelling = parseFloat(String(node.netSelling??0)?.replace(/,/g, ''));
                const currentOverRiding = parseFloat(String(childNode.parentOverRiding??0).replace(/,/g, ''));
                const salesCommission = parseFloat(String(node.currentDealClosure??0).replace(/,/g, ''));
                const overRiding = parseFloat(String(childNode.overRiding??0).replace(/,/g, ''));
                const dealClosure = parseFloat(String(childNode.totalFinalCommission??0).replace(/,/g, ''));
                const isChecked = updatedCheckedItems.includes(id);
                if (isCurrentlyChecked) {
                    if (isChecked){
                        updatedCheckedItems = updatedCheckedItems.filter(item => item !== id);
                        updatedToggledItems = updatedToggledItems.filter(item => item !== id);
                        if (childNode.hasBulletList){
                            totalCommission = Math.max(0, totalCommission - salesCommission);
                            // totalNetSales = Math.max(0, totalNetSales - netSelling - currentOverRiding);
                        }else if (!childNode.parentItem){
                            node.checked = false;
                            childNode.checked = false;
                            // totalNetSales = Math.max(0, totalNetSales- netSelling - currentOverRiding);
                            totalCommission = Math.max(0, totalCommission - dealClosure);
                        }
                    }
                } else {
                    if (!isChecked) {
                        updatedCheckedItems.push(id);
                        updatedToggledItems.push(id);
                        if (childNode.hasBulletList){
                            // const exists = CommissionItemListData.find(item=>item.children.some(child=>child.id?.toLowerCase()===id?.toLowerCase()))
                            if (findParentNode(CompanyCommissionOptions, id)?.children?.length > 0){
                                //findParentNode(CommissionItemListData, id),
                            }
                            totalCommission += salesCommission;
                            // totalNetSales += netSelling ;
                        }else if (!childNode.parentItem){
                            node.checked = true;
                            childNode.checked = true;
                            // totalNetSales += netSelling ;
                            totalCommission += dealClosure;
                        }
                    }
                }
            });
    
            updatedCheckedItems = syncParentCheckStates(nodeId, updatedCheckedItems);
            updatedToggledItems = syncParentCheckStates(nodeId, updatedToggledItems)
            updateParentCommission(nodeId, updatedCheckedItems);
            
            let currentId = nodeId;
            while (true) {
                const parent = findParent(currentId, CompanyCommissionOptions);
                if (!parent || !parent.children) break;
    
                const allChildrenChecked = parent.children.every((c: any) =>
                    updatedCheckedItems.includes(c.id)
                );
                const someChildrenChecked = parent.children.some((c:any) =>
                    updatedToggledItems.includes(c.id)
                );
                const parentIsChecked = updatedCheckedItems.includes(parent.id);
                const parentIsChecked2 = updatedToggledItems.includes(parent.id);
                const parentNetSelling = parseFloat(String(parent.netSelling??0)?.replace(/,/g, ''));
    
                if (allChildrenChecked && !parentIsChecked) {
                    updatedCheckedItems.push(parent.id);
                    totalNetSales += parentNetSelling;
                } else if (!allChildrenChecked && parentIsChecked) {
                    updatedCheckedItems = updatedCheckedItems.filter(id => id !== parent.id);
                    totalNetSales = Math.max(0, totalNetSales - parentNetSelling);
                }
                if (someChildrenChecked&& !parentIsChecked2){
                    updatedToggledItems.push(findParent(parent.id, CompanyCommissionOptions)?.id);
                    totalNetSales += parentNetSelling;
                } 
                currentId = parent.id;
            }
            function trackAllItems(node: any, dataList: any[], dataListDetail: any[]){
                const checkState = getNodeCheckState(node.id)
                const itemSelected = updatedToggledItems.includes(node.id)
                if (itemSelected){
                    if(node.parentItem){
                        dataList.push({
                            generateDate: submittedDateInput,  
                            companyId: node.companyId,
                            employeeId: node.employeeId,
                            employeeName: node.employeeName,
                            principal: node.principal,
                            totalSelling: node.netSelling,
                            totalCommission: node.salesCommission,
                        });
                    }
                    if (node.hasBulletList){
                        dataListDetail.push({
                            companyCommissionPackageId: node.companyCommissionPackageId,
                            companyId: node.companyId,
                            saleId: node.saleId,
                            employeeId: node.employeeId,
                            docDate: node.docDate,
                            principal: node.principal,
                            docNo: node.docNo,
                            netSelling: node.netSelling,
                            commissionType: node.commissionType,
                            commissionDate: node.salesRegistrationDate,
                            commissionAmt: node.finalCommission
                        });
                    }    
                } 
                if (node.children&&Array.isArray(node.children)){
                for (const child of node.children){
                trackAllItems(child, dataList, dataListDetail)
                }
                }
            }
            const result = [];
            const resultDetail = [];
            totalNetSales = 0;
            updatedToggledItems.forEach((itemData)=>{
                const existItem = findNodeById(itemData)
                if (existItem?.parentItem){
                    totalNetSales += existItem.netSelling;
                }
            })
            for (const checkedItem of CompanyCommissionOptions){
                trackAllItems(checkedItem, result, resultDetail);
            }
            for (const item of result){
                const {employeeId, principal } = item;
                const parentDetail = resultDetail.filter(
                    entity=>entity.employeeId === employeeId && entity.principal===principal
                );
                const sumCommission = parentDetail.reduce((prev, next)=>(prev+(next.commissionAmt||0)),0)
                item.totalCommission = sumCommission;
                
            }
            setCheckedDetailData(resultDetail);
            setCheckedData(result);
        }

        setCheckedItems(updatedCheckedItems);
        setValue('netSales', totalNetSales);
        setValue('commissionAmount', totalCommission);
        
        return updatedCheckedItems;
    };
    const findNodeById = (id: string) => {
        const search = (nodes: any[]): any => {
            if (tabIndex===0){
                for (const node of nodes) {
                    if (node.id === id) return node;
                    if (node.children) {
                        const childResult = search(node.children);
                        if (childResult) return childResult;
                    }
                }
            }else {
                for (const node of nodes) {
                    if (node.id === id) return node;
                    if (node.children) {
                        const childResult = search(node.children);
                        if (childResult) return childResult;
                    }
                }
            }
            return null;
        };
        return search(tabIndex===0?CommissionItemListData: CompanyCommissionOptions); 
    };  
    const collectAllDescendantIds = (n: any): string[] => {
        let ids: string[] = [n.id];
        if (n.children) {
            n.children.forEach((child: any) => {
                ids.push(child.id);
                ids = ids.concat(collectAllDescendantIds(child));
            });
        }
        // if (tabIndex!==0 && n.children){
        //     for (const payment of n.commissionPayments){
        //         ids.push(payment.id);
        //         if (payment.children){
        //             for (const subChild of payment.children){
        //                 ids.push(subChild.id);
        //             }
        //         }
        //     }
        // }
        return ids;
    };
    const collectAllNodeIdsIncludingSelf = (node: any): string[] => {
        const ids = [node.id];
        if (node.children) {
            for (const child of node.children) {
            ids.push(...collectAllNodeIdsIncludingSelf(child));
            }
        }
        return ids;
    };
    const findParent = (id: string, nodes: any[], parent: any = null): any => {
        for (const node of nodes) {
            if (node.id === id) return parent;
            if (node.children) {
            const result = findParent(id, node.children, node);
            if (result) return result;
            }
        }
        return null;
    };
    const syncParentCheckStates = (nodeId: string, updatedChecked: string[]): string[] => {
        let currentId = nodeId;
        while (true) {
          const parent = tabIndex===0?findParent(currentId, CommissionItemListData):
          findParent(currentId, CompanyCommissionOptions);
          if (!parent) break;
      
          const allChildIds = collectAllDescendantIds(parent);
          let directChildIds = parent.children?.map((c: any) => c.id) || [];
      
          if ( parent.children){
            directChildIds
          } 
          const allChildrenChecked = directChildIds.every(id => updatedChecked.includes(id));
          const someChildrenChecked = directChildIds.some(id => updatedChecked.includes(id));
          const allChildrenUnchecked = directChildIds.every(id => !updatedChecked.includes(id));
          if (allChildrenChecked) {
            if (!updatedChecked.includes(parent.id)) {
              updatedChecked.push(parent.id);
            }
          } if (someChildrenChecked) {
            if (!updatedChecked.includes(parent.id)) {
              updatedChecked.push(parent.id);
            }
          } if (allChildrenUnchecked) {
            updatedChecked = updatedChecked.filter(id => id !== parent.id);
          }
      
          currentId = parent.id;
        }
      
        return updatedChecked;
    };
      
    const getNodeCheckState = useCallback((nodeId: string): 'checked' | 'indeterminate' | 'unchecked' => {
        const node = findNodeById(nodeId);
        if (!node) return 'unchecked';   
    
        const allIds = collectAllDescendantIds(node);
        if (allIds.length===0){
            return checkedItems.includes(nodeId) ? 'checked' : 'unchecked';
        }
        
        const checkedCount = allIds.filter(id => checkedItems.includes(id)).length;
        if (checkedCount === allIds.length) 
            return checkedItems.includes(nodeId) ? 'checked' : 'indeterminate';
       
        if (checkedCount > 0) return 'indeterminate';
        return 'unchecked';
    },[checkedItems]);

    function thousandSeparator(value) {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    }

    function dateSeparator(dateString) {
        if (!dateString) return
        let date
        if (dateString.includes('/')) {
            const [day, month, year] = dateString.split('/');
            date = new Date(`${year}-${month}-${day}`);
        } else {
            date = new Date(dateString);
        }
        if (isNaN(date.getTime())) return "Unknown Date";
        return new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        }).format(date); 
    }
    
    function monthSeparator(dateString) {
        if (!dateString) return
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-GB', {
            month: 'short',
            year: 'numeric'
        }).format(date); 
    }
    return (
    <>
        <SubContainerX>
            <Box display="flex">
                <Box width={'100%'}>
                    <Tabs
                        className="bill-item-tabs"
                        value={tabIndex}
                        onChange={(e, v) => setTabIndex(v)}
                        variant="fullWidth"
                        centered
                        style={{ width: '100%' }}
                    >
                        {tabs.map((tab, i) => (
                            <Tab
                                key={i}
                                value={i}
                                style={ { flexGrow: 1, maxWidth: '100%'}}
                                label={
                                <Typography className="text-mdLabel">{tab.label}</Typography>
                                }
                            />
                        ))}    
                    </Tabs>
                </Box>
            </Box>
        </SubContainerX>
        <Container>
            <Card >
                <Box sx={{width:1}}>
                    <form id='create-form' >
                        <Box sx={{display:"flex", justifyContent:"space-between", gap:"10px"}}>
                            <Box sx={{pl:1, width:"100%"}}>
                                <Controller 
                                    control={control}
                                    name='selectDate'
                                    render={({ field: { onChange, onBlur, value } }) => (
                                        <>
                                        <MobileDatePicker
                                            label="Select Date"
                                            value={(submittedDateInput as string) || value}
                                            inputFormat="dd/MM/yyyy"
                                            toolbarFormat="dd/MM/yyyy"
                                            onAccept={date=>{
                                                const dateFormat = moment(date, 'DD/MM/YYYY')
                                                .utcOffset('+0800')
                                                .set({
                                                    hour: moment().hour(),
                                                    minute: moment().minute(),
                                                    second: moment().second(),
                                                })
                                                .format('DD/MM/YYYY HH:mm:ss');
                                                setValue('selectDate', dateFormat);
                                            }}
                                            onChange={value => {
                                                // onChange(dateFormat)
                                                setSubmittedDateInput(new Date(value))
                                            }}
                                            renderInput={params => (
                                                <TextField
                                                {...params}
                                                autoComplete="off"
                                                name="launchDate"
                                                onBlur={onBlur}
                                                fullWidth
                                                margin="normal"
                                                variant="standard"
                                                required
                                                InputProps={{
                                                    endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton>
                                                        <CalendarIcon sx={{ width: 20 }} />
                                                        </IconButton>
                                                    </InputAdornment>
                                                    ),
                                                }}
                                                />
                                            )}
                                        />
                                        </>
                                    )}
                                />
                            </Box>
                            <FooterButton color='primary' variant="contained" 
                            sx={{
                                margin: '27px 18px 13px 9px',
                                alignItems:"bottom",
                                padding:"10px 100px"
                            }}
                            disabled={!hasSelectedDate}
                            onClick={()=>{handleGenerate()}}
                            >
                                Generate
                            </FooterButton>    
                        </Box>
                    </form>
                </Box>
            </Card>                        
        </Container>
        {/* <Container> */}
        <Box display={generated?"block":"none"}>
            <TreeView
                key={`tree-view-${tabIndex}`}
                expanded={expanded}
                onNodeToggle={handleToggle}
                sx={{
                    width: '100%',
                    marginBottom: '180px',
                    [`& .${treeItemClasses.selected}`]: {
                      background: 'inherit !important', 
                      color: 'inherit !important', 
                    },
                    [`& .${treeItemClasses.focused}`]: {
                      background: 'inherit !important',
                    },
                    [`& .MuiTreeItem-content`]: {
                        paddingLeft: 0,
                        marginLeft:-1,
                    },
                  }}
            >
                {(tabIndex===0?CommissionItemListData:CompanyCommissionOptions)?.map((node, nodeIndex) => (
                    <TreeItem 
                        key={node.id}
                        label={
                            <Box 
                                sx={{
                                    display: "flex", 
                                    justifyContent: "space-between",
                                    background: 'white',
                                    mb: 1,
                                    width: '100%',
                                    borderRadius: '4px'
                                }}
                                onClick={(e) => handleExpandClick(e, node.id)}
                            >
                            <IconButton
                                size="small"
                                onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleExpandClick(e, node.id);
                                }}
                            >
                                {expanded.includes(node.id) ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </IconButton>
                            <Box
                                sx={{
                                padding: "4px 8px",
                                display: "block",
                                justifyContent:"space-between",
                                paddingTop: 1, 
                                paddingBottom: 1,
                                cursor: "pointer",
                                backgroundColor:"white",
                                width:"100%",
                                mr: -1,
                                "&:hover": { backgroundColor: "inherit" },
                                }}
                            >
                                <Typography className='text-xsTitle' sx={{fontWeight:"bold !important"}}>{node.name}</Typography>
                                <Box sx={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                                <Typography className='text-desc'>{node.position}</Typography>
                                <Typography className='text-desc'>{node.employeeName}</Typography>
                                </Box>
                                <Box sx={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                                    <Typography className='text-desc'>Net Selling:</Typography>
                                    <Typography className='text-desc' color="primary">{thousandSeparator(node.netSelling)}</Typography>
                                </Box>
                                <Box sx={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                                    <Typography className='text-desc'>{tabIndex===0?'Sales Commission':'Company Reward'}:</Typography>
                                    <Typography className='text-desc' color="primary">{thousandSeparator(node.salesCommission)}</Typography>
                                </Box>
                            </Box>
                            <Box sx={{
                                padding: "4px 8px",
                                display: "flex",
                                justifyContent:"space-between",
                                paddingTop: 1, 
                                paddingBottom: 1,
                                cursor: "pointer",
                                }}>
                                <IconButton 
                                key={checkedItems.join(',')}
                                onClick={e => {
                                e.preventDefault(); 
                                e.stopPropagation();
                                toggleCheck(node.id);
                                }}
                                >
                                    {{
                                        checked: <CheckBoxIcon style={{ color: '#ff9900' }} />,
                                        indeterminate: <IndeterminateCheckBoxIcon style={{ color: '#ff9900' }} />,
                                        unchecked: <CheckBoxOutlineBlankIcon style={{ color: '#212121' }} />,
                                    }[getNodeCheckState(node.id)]}
                                </IconButton>
                            </Box>
                            </Box>
                        }
                        sx={{
                            "&.Mui-focused, & .MuiTreeItem-content.Mui-focused, & .MuiTreeItem-content.Mui-selected, & .MuiTreeItem-content:hover": {
                                backgroundColor: "inherit !important",
                                color: "inherit !important",
                            },
                            "& .MuiTreeItem-content.Mui-expanded": {
                                backgroundColor: "inherit !important",
                                color: "inherit !important",
                            },
                            '& .MuiTreeItem-content': {
                                paddingRight: '0px !important',
                                paddingLeft: '0px !important',
                            },
                            "&.MuiTreeItem-root": {
                                paddingLeft: 0,
                                marginLeft: '-4px',
                            },
                            '& .MuiTreeItem-label': {
                                paddingLeft: '0 !important',
                                paddingRight: '0 !important',
                            },
                            '& .MuiTreeItem-group': {
                                marginLeft: 0,
                                marginRight: 0,
                            },
                        }} 
                        nodeId={node.id}
                    >
                        {(node?.children)?.map((child, childIndex) => (
                        <TreeItem
                            key={child.id}
                            nodeId={String(child.id)}
                            label={
                                <Box sx={{display: "flex", 
                                    justifyContent: "space-between", 
                                    width:"auto",
                                    background: 'white',
                                    mb: 1,
                                    borderRadius: '4px',
                                    mx: 2,
                                    }}>
                                    <IconButton
                                        size="small"
                                        onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleExpandClick(e, child.id);
                                        }}
                                    >
                                        {expanded.includes(child.id) ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </IconButton>
                                    <Box sx={{display:"flex", justifyContent:"space-between", width:"100%", mr:1, my: 1}}>
                                        <Box sx={{width:"100%"}}>
                                        <Typography className='text-desc' 
                                            sx={{paddingTop: 0, 
                                            paddingBottom: 0, fontWeight:"600 !important"}}>
                                            {child.unitNo}
                                        </Typography>
                                        <Box sx={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                                            <Box sx={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                                                <Typography className='text-desc'>{dateSeparator(child.effectiveDate)}</Typography>
                                                <Typography className='text-desc'>{child.description}</Typography>
                                            </Box>
                                        </Box>
                                        <Box sx={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                                            <Typography className='text-desc'>Net Selling:</Typography>
                                            <Typography className='text-desc' color="primary">{thousandSeparator(child.netSelling)}</Typography>
                                        </Box>
                                        <Box sx={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                                            <Typography className='text-desc'>{tabIndex===0?'Sales Commission':'Company Reward'}:</Typography>
                                            <Typography className='text-desc' color="primary">{thousandSeparator(child.salesCommissionData)}</Typography>
                                        </Box>
                                        </Box>
                                    </Box>
                                    <IconButton 
                                    onClick={e => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    toggleCheck(child.id);
                                    }} sx={{paddingRight:2}}>
                                    {{
                                        checked: <CheckBoxIcon style={{ color: '#ff9900' }} />,
                                        indeterminate: <IndeterminateCheckBoxIcon style={{ color: '#ff9900' }} />,
                                        unchecked: <CheckBoxOutlineBlankIcon style={{ color: '#212121' }} />,
                                    }[getNodeCheckState(child.id)]}
                                    </IconButton>
                                </Box>
                            }
                            sx={{
                                "& .MuiTreeItem-content.Mui-focused": {
                                backgroundColor: "transparent !important",
                                },
                                "& .MuiTreeItem-content.Mui-selected": {
                                backgroundColor: "transparent !important",
                                },
                                "& .MuiTreeItem-content:hover": {
                                backgroundColor: "rgba(0, 0, 0, 0.04) !important",
                                },
                                "&.Mui-focused, & .MuiTreeItem-content.Mui-focused, & .MuiTreeItem-content.Mui-selected, & .MuiTreeItem-content:hover": {
                                backgroundColor: "inherit !important",
                                color: "inherit !important",
                                },
                                "& .MuiTreeItem-content.Mui-expanded": {
                                backgroundColor: "inherit !important",
                                color: "inherit !important",
                                },
                            }}
                        >
                            {child?.children?.map((subChild, subChildIndex) => (
                            <TreeItem key={subChildIndex} nodeId={subChild.id} 
                                label={
                                    <>
                                    <Box sx={{
                                        display:"flex", 
                                        width:"auto", 
                                        justifyContent:"space-between", 
                                        alignItems:"center", 
                                        pr:'9px', 
                                        backgroundColor:'#f0efed', 
                                        mb:1, 
                                        borderRadius:'4px',
                                        mx: 4,
                                        }} key={subChildIndex}>
                                        <Box sx={{width:"100%", display:'flex', pb:1}}>
                                            <Box sx={{px:1, alignItems:"center", display:"flex"}}>
                                            <b>•</b>
                                            </Box>
                                            <Box sx={{my: 1, mr: 1, width: "100%"}}>
                                                <Typography key={subChildIndex} variant="body1" sx={{ display: "flex", alignItems: "center", gap: 1, fontWeight: '500 !important' }} className="text-desc">
                                                    {subChild.description}
                                                </Typography>
                                                <Typography className='text-desc'>{monthSeparator(subChild.effectiveDate)}</Typography>
                                                <Box sx={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                                                    <Typography className='text-desc'>Amount:</Typography>
                                                    <Typography className='text-desc' color="primary">{thousandSeparator(subChild.dealClosure)}</Typography>
                                                </Box>
                                            
                                            </Box>
                                        
                                        </Box>
                                        <IconButton onClick={e => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            toggleCheck(subChild.id);
                                            }}>
                                            {{
                                                checked: <CheckBoxIcon style={{ color: '#ff9900' }} />,
                                                indeterminate: <IndeterminateCheckBoxIcon style={{ color: '#ff9900' }} />,
                                                unchecked: <CheckBoxOutlineBlankIcon style={{ color: '#212121' }} />,
                                            }[getNodeCheckState(subChild.id)]}            
                                        </IconButton>
                                    </Box>
                                    </>
                                }
                                sx={{[`& .${treeItemClasses.group}`]: {
                                    marginLeft: '14.5px !important',
                                    paddingLeft: '12px !important',
                                    borderLeft: '0px !important',
                                }}}
                            >
                                
                            </TreeItem>
                            ))}
                        </TreeItem>  
                        ))}
                    </TreeItem> 
                ))}
            </TreeView>
        </Box>
        {/* </Container> */}
        <FooterFixedRoot width={1} display={"flex"} justifyContent={"center"} gap={'10%'}>
            <Box width={"100%"} sx={{justifyContent:"center"}}>
            <Box width={1} sx={{display:generated?"block":"none"}}>
                <Box
                    sx={{
                    backgroundColor: '#FFA500',
                    color: 'white',
                    padding: '16px',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'column',
                    marginBottom: '0px',
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography className="text-desc" fontWeight="bold">Net Selling Price:</Typography>
                    <Typography className="text-desc" fontWeight="bold">{getValues('netSales').toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography className="text-desc" fontWeight="bold">{tabIndex===0?'Commission Amt:':'Reward Amt:'}</Typography>
                    <Typography className="text-desc" fontWeight="bold">{getValues('commissionAmount').toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Typography>
                    </Box>
                </Box>
            </Box>
            <Box sx={{
                display: 'flex', 
                justifyContent: 'center', 
                width:'100%', 
                gap: 1,
                }}>

                <FooterButtonContainer sx={{padding:'10px 0px!important'}}
                >
                    <FooterButton 
                        variant="contained" 
                        disabled={!generated}
                        sx={{
                            backgroundColor: !generated?'#A9A9A9 !important':'primary.main',
                            color: 'white !important',
                            margin: '8px 18px 8px 9px',
                            alignItems:"bottom",
                            padding:"10px 100px"
                        }}
                        onClick={()=>{
                            navTo(`/sales-commission/${projectID}/commission-calculation`,{
                                state:{projectID, tabIndexData: tabIndex}
                            });
                        }}
                    >
                        Cancel
                    </FooterButton>
                </FooterButtonContainer>
                <FooterButtonContainer sx={{padding:'10px 0px!important'}}>
                    <FooterButton 
                    variant="contained" 
                    disabled={!generated}
                    sx={{
                        backgroundColor: !generated?'#A9A9A9 !important':'primary.main',
                        color: 'white !important',
                        margin: '8px 18px 8px 9px',
                        alignItems:"bottom",
                        padding:"10px 100px"
                    }}
                    onClick={()=>handleCreate()}>
                        Confirm
                    </FooterButton>
                </FooterButtonContainer>
            </Box>
            </Box>
        </FooterFixedRoot>
    </>)
}